import React, { useEffect, useState, useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { ChevronUp } from 'feather-icons-react/build/IconComponents';
import { setToogleHeader } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable';
import Loader from '../loader/loader';
import { useToast } from '../../Toaster/ToastContext';
import { apiClient } from '../../services/apiClient';

const ExpiredProduct = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [originalExpiredProducts, setOriginalExpiredProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const isDeleting = useRef(false);
    const [permissions, setPermissions] = useState({
        create: false,
        read: false,
        update: false,
        delete: false,
    });

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );

    useEffect(() => {
        const storedPermissions = localStorage.getItem("rolespermissions");
        let parsedPermissions = [];
        try {
            const Permissions = JSON.parse(storedPermissions);
            const getPermissions = JSON.parse(Permissions.permissions)
            if(getPermissions.permissions){
                parsedPermissions = getPermissions.permissions;
            }
            else {
                parsedPermissions = getPermissions;
            }
        
            const inventoryPermissions = parsedPermissions.find(
                (item) => item.title === "Inventory"
            );

            const productPermissions = inventoryPermissions?.childPage?.find(
                (child) => child.title === "Expired Products"
            );
            // console.log("search product", productPermissions)

            if (productPermissions) {
                setPermissions({
                    create: productPermissions.create || false,
                    read: productPermissions.read || false,
                    update: productPermissions.update || false,
                    delete: productPermissions.delete || false,
                });
            } else {
                console.error("Product permissions not found in localStorage");
                showToast("Product permissions not found.", "error", "Permissions Error");
            }
        } catch (error) {
            console.error("Error parsing permissions from localStorage:", error);
            showToast("Failed to load permissions.", "error", "Permissions Error");
        }
    }, []);

    const fetchExpiredProducts = async () => {
        try {
            setLoading(true);
            const response = await apiClient.get('/get-all-products');
            const products = response.data;
            const currentDate = new Date();
            const expiredProducts = products.filter(product => product.expiry_on && new Date(product.expiry_on) < currentDate)
                .map(product => ({
                    id: product.id || '',
                    product: product.name || 'No Name',
                    sku: product.sku || 'No SKU',
                    manufactureddate: product.manufacturer_date || 'N/A',
                    expireddate: product.expiry_on || 'N/A',
                    img: Array.isArray(product.image) ? product.image[0] : product.image || '',
                }));
            setOriginalExpiredProducts(expiredProducts);
            setFilteredProducts(expiredProducts);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchExpiredProducts();
    }, []);

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        if(term == ''){
            setFilteredProducts(originalExpiredProducts);
        }
        const filtered = originalExpiredProducts.filter(product =>
            product.product.toLowerCase().includes(term) ||
            product.sku.toLowerCase().includes(term)
        );
        setFilteredProducts(filtered);
    };

    const columns = [
        {
            title: "Product",
            dataIndex: "product",
            render: (text, record) => (
                <span className="productimgname">
                    <Link to="#" className="product-img stock-img">
                        <ImageWithBasePath alt="" src={record.img || 'assets/img/product/noimage.png'} />
                    </Link>
                    {text}
                </span>
            ),
            sorter: (a, b) => a.product.length - b.product.length,
            width: "5%"
        },
        {
            title: "SKU",
            dataIndex: "sku",
            sorter: (a, b) => a.sku.length - b.sku.length,
        },
        {
            title: "Manufactured Date",
            dataIndex: "manufactureddate",
            render: (text) => {
                const date = new Date(text);
                return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).split('/').join('-');
            },
            sorter: (a, b) => a.manufactureddate.length - b.manufactureddate.length,
        },
        {
            title: "Expired Date",
            dataIndex: "expireddate",
            render: (text) => {
                const date = new Date(text);
                return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).split('/').join('-');
            },
            sorter: (a, b) => a.expireddate.length - b.expireddate.length,
        },
        {
            title: 'Action',
            dataIndex: 'actions',
            key: 'actions',
            render: (_, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        {(permissions.delete) && (
                        <Link className="confirm-text p-2" to="#"  >
                            <i data-feather="trash-2" className="feather-trash-2" onClick={() => showConfirmationAlert(record)}></i>
                        </Link>
                        )}
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#ff0000',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    isDeleting.current = true;
                    const response = await apiClient.delete(`/delete-product/${record.id}`)
                    const data = await response;
                    if (data.success) {
                        showToast('Product deleted successfully', 'success', 'Product Operation!');
                        await fetchExpiredProducts();
                    } else {
                        showToast(data.message || 'Failed to delete product', 'error', 'Product Operation!');
                    }
                } catch (error) {
                    showToast(error.message || 'Failed to delete product', 'error', 'Product Operation!');
                } finally {
                    setLoading(false);
                    isDeleting.current = false;
                }  
            } else {
                MySwal.close();
            }

        });
    };
    return (
        <div>
            <Loader loading={loading} />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Expired Products</h4>
                                <h6>Manage your expired products</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            onChange={handleSearch}
                                        />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <Table columns={columns} dataSource={filteredProducts} rowSelection={null} />
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
        </div>
    )
}

export default ExpiredProduct
